export default __webpack_public_path__ + "static/media/stage_requested.2f6a77bd.svg";